export const WIDGET_ID_PARAM = 'widget_id'
export const CLID_PARAM = 'clid'
export const EXPORT_MODE_PARAM = 'export_mode'
export const GAME_DISTRIBUTION_PARAM = 'use_gd_ads'

const REDIRECT_COUNTER_PARAM = 'redirCnt'
const REDIRECT_MAX_COUNT = 5

export const addRedirectCounter = (url: URL) => {
    const redirCnt = parseInt(url.searchParams.get(REDIRECT_COUNTER_PARAM) || '0')

    if (redirCnt > REDIRECT_MAX_COUNT) {
        return
    }

    url.searchParams.set(REDIRECT_COUNTER_PARAM, (redirCnt + 1).toString())

    return url
}
